export default class Quiz {
	constructor() {
		this.forms = document.querySelectorAll('[data-quiz]')
		this.forms.forEach(form => this.#setup(form))

		document.querySelectorAll('[data-quiz-copy]').forEach(button => {
			button.addEventListener('click', () => this.#copyLink(button))
		})

		document.querySelectorAll('[data-see-and-do-filter]').forEach(section => {
			this.#setupRegionTabs(section)
		})
	}

	#setupRegionTabs(section) {
		const tabs = section.querySelectorAll('[data-quiz-region]')
		const cards = section.querySelectorAll('[data-quiz-card]')
		if (!tabs.length || !cards.length) return

		tabs.forEach(tab => {
			tab.addEventListener('click', () => {
				const region = tab.dataset.quizRegion
				tabs.forEach(t => t.classList.toggle('active', t === tab))
				cards.forEach(card => {
					const match = region === 'all' || card.dataset.region === region
					card.classList.toggle('hidden', !match)
				})
			})
		})
	}

	async #copyLink(button) {
		const label = button.querySelector('[data-quiz-copy-label]') || button
		const original = label.textContent
		try {
			await navigator.clipboard.writeText(window.location.href)
			label.textContent = 'Link copied'
		} catch {
			label.textContent = 'Copy failed'
		}
		setTimeout(() => {
			label.textContent = original
		}, 1800)
	}

	#setup(form) {
		const steps = Array.from(form.querySelectorAll('[data-quiz-step]'))
		if (!steps.length) return

		const state = {
			form,
			steps,
			current: 0,
			answers: steps.map(step => ({
				id: step.dataset.quizQuestionId,
				value: null,
			})),
		}

		steps.forEach((step, index) => {
			const options = step.querySelectorAll('[data-quiz-option]')
			options.forEach(option => {
				option.addEventListener('click', () =>
					this.#toggleOption(state, index, option, options)
				)
			})

			step.querySelector('[data-quiz-prev]')?.addEventListener('click', () =>
				this.#go(state, state.current - 1)
			)
			step.querySelector('[data-quiz-next]')?.addEventListener('click', () =>
				this.#next(state)
			)
		})

		this.#render(state)
	}

	#toggleOption(state, stepIndex, option, allOptions) {
		const answer = state.answers[stepIndex]
		answer.value = option.dataset.value

		allOptions.forEach(o => {
			o.setAttribute(
				'aria-pressed',
				o.dataset.value === answer.value ? 'true' : 'false'
			)
		})

		this.#updateNav(state)
	}

	#next(state) {
		if (!state.answers[state.current].value) return
		if (state.current >= state.steps.length - 1) {
			this.#submit(state)
			return
		}
		this.#go(state, state.current + 1)
	}

	#go(state, index) {
		if (index < 0 || index >= state.steps.length) return
		state.current = index
		this.#render(state)
	}

	#render(state) {
		state.steps.forEach((step, i) => {
			step.classList.toggle('hidden', i !== state.current)

			step.querySelectorAll('[data-quiz-dot]').forEach(dot => {
				const idx = Number(dot.dataset.quizDot)
				dot.classList.toggle('bg-sand', idx === state.current)
				dot.classList.toggle('bg-sand/30', idx !== state.current)
			})

			const prev = step.querySelector('[data-quiz-prev]')
			if (prev) prev.disabled = state.current === 0
		})

		this.#updateNav(state)
	}

	#updateNav(state) {
		const step = state.steps[state.current]
		if (!step) return
		const next = step.querySelector('[data-quiz-next]')
		if (!next) return
		next.disabled = !state.answers[state.current].value
	}

	#submit(state) {
		const payload = state.answers.reduce((acc, a) => {
			acc[a.id] = a.value
			return acc
		}, {})

		state.form.dispatchEvent(
			new CustomEvent('quiz:complete', { detail: payload, bubbles: true })
		)

		const url = state.form.dataset.quizResultsUrl || window.location.pathname
		const params = new URLSearchParams()
		Object.entries(payload).forEach(([k, v]) => {
			if (v != null) params.set(k, v)
		})
		window.location.href = `${url}?${params.toString()}`
	}
}
